import {Component, OnInit} from '@angular/core';
import {MdDialogRef} from '@angular/material';

@Component({
    selector: 'dialog',
    templateUrl: './templates/dialog.component.html',
    styles: []

})

/*@Component({
  selector: 'dialog-result-example-dialog',
  templateUrl: 'dialog-result-example-dialog.html',
})*/
/*export class DialogComponent {
    constructor(public dialogRef: MdDialogRef<DialogComponent>) {}
}*/

    export class DialogComponent implements OnInit {
    name = 'Dialogue';

    constructor(){
    }
    ngOnInit(): void {

    }
    
}





// WEBPACK FOOTER //
// ./src/app/dialog.component.ts